import apiClient from './apiClient';

export const leaderboardService = {
  getLeaderboard: (page = 1, item = 50) =>
    apiClient
      .get('/leaderboard', { params: { page, item } })
      .then((res) => res.data),
};
